import {Fab, FabProps, IconButton} from '@mui/material';
import LFCConfirmDialog from '_components/feedback/LFCConfirmDialog';
import React, {cloneElement, isValidElement, useState} from 'react';

/**
 * 引数
 */
interface Props {
  children: React.ReactNode;
  onClick: (isOk: boolean) => void;
  color?: FabProps['color'];
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  // 確認ダイアログ付にしたい場合、以下を設定
  confirmMessage?: string;
  // スタイル関連
  className?: string;
  sx?: FabProps['sx'];
}

/**
 * LFCIconButton
 * LFCの標準アイコンボタンです。確認ダイアログ付のボタンにも出来ます。
 * colorを指定すると背景色付きの丸型ボタンになります（Fabベース）。
 * colorを指定しない場合は通常のIconButtonになります。
 * sizeに連動してアイコンサイズも自動調整されます。
 * @param props
 * @returns
 */
const LFCIconButton = (props: Props) => {
  const [open, setOpen] = useState(false);

  // colorが指定されているか（default/inherit以外）
  const hasColor = props.color && props.color !== 'default' && props.color !== 'inherit';

  // sizeに対応するアイコンのfontSize
  const iconFontSize =
    props.size === 'large' ? 'large' : props.size === 'small' ? 'small' : 'medium';

  // 共通スタイル
  const baseStyles = {marginRight: '5px'};

  // Fabのサイズ調整（smallの場合はより小さく）
  const fabSizeStyles =
    props.size === 'small'
      ? {width: 32, height: 32, minHeight: 32}
      : props.size === 'large'
        ? {width: 56, height: 56, minHeight: 56}
        : {width: 40, height: 40, minHeight: 40};

  // childrenにfontSizeを注入
  const iconWithSize = isValidElement(props.children)
    ? cloneElement(props.children as React.ReactElement<{fontSize?: string}>, {
        fontSize: iconFontSize
      })
    : props.children;

  /**
   * ボタンクリック
   * @returns
   */
  const onButtonClick = () => {
    if (props.confirmMessage != null) {
      //確認ダイアログONの場合
      setOpen(true);
      return;
    }
    props.onClick(true);
  };

  /**
   * 確認ダイアログ閉じる
   */
  const onDialogClose = (isOk: boolean) => {
    setOpen(false);
    props.onClick(isOk);
  };

  return (
    <>
      {hasColor ? (
        <Fab
          onClick={onButtonClick}
          size={props.size}
          color={props.color}
          disabled={props.disabled}
          className={props.className}
          sx={{...baseStyles, ...fabSizeStyles, ...props.sx}}
        >
          {iconWithSize}
        </Fab>
      ) : (
        <IconButton
          onClick={onButtonClick}
          size={props.size}
          disabled={props.disabled}
          className={props.className}
          sx={{...baseStyles, ...props.sx}}
        >
          {iconWithSize}
        </IconButton>
      )}
      {/* 確認ダイアログ */}
      {props.confirmMessage != null ? (
        <LFCConfirmDialog
          open={open}
          message={props.confirmMessage}
          onClose={onDialogClose}
        ></LFCConfirmDialog>
      ) : null}
    </>
  );
};

export default LFCIconButton;
